export default {
  'error:title': 'Сервис временно<br />недоступен',
  'error:text': 'Мы уже работаем над устранением проблемы. Попробуйте повторить попытку через 15 минут',
  'error:btn-text': 'OK'
}
